<div class="container-fluid">


  <h4 id="upper">Revue Budgétaire</h4>

  <div class="d-flex justify-content-end">


    <!-- Selectbox pour Projet -->
    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Programmes:
          <select type="text" name="Programmes" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedProgramme">
            <option [value]="'DEFAULT'">Sélectionner un Programmes</option>
            <option *ngFor="let item of programmeItems" [value]="item?.reference"> {{ item?.libelle}}
            </option>
          </select>
        </label>
      </div>
    </div>

    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Action:
          <select style="width: 200px;" type="text" name="action" class="form-select ms-2" aria-controls="tickets-table"
            [(ngModel)]="selectedAction">
            <option disabled value="Sélectionner une action"></option>
            <option *ngFor="let item of actionItems" [value]="item.id"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>
    <!-- Selectbox pour Direction -->
    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Direction:
          <select style="width: 200px;" type="text" name="direction" class="form-select ms-2"
            aria-controls="tickets-table" [(ngModel)]="selectedDirection">
            <option disabled value="Sélectionner une direction"></option>
            <option *ngFor="let item of directionItems" [value]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div>



    <!-- Bouton Rechercher -->
    <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <input (click)="fetchRevueBudgetaire()" type="button" value="Rechercher" class="btn btn-primary">
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">

        <div class="card-body">
          <div>

          </div>

          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light rwd-table">
                <tr>
                  <th>Code </th>
                  <th>Libellé </th>
                  <th>Date début </th>
                  <th>Date fin </th>
                  <th>Poids</th>
                  <th>Montant </th>
                  <th style="width: 120px;">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of paginatedItems ; let index = index">
                  <td>{{item?.code}}</td>
                  <td>{{item?.libelle}}</td>
                  <td>{{item?.date_debut | dateFormat}}</td>

                  <td>{{item?.date_fin | dateFormat}}</td>
                  <td>{{item?.poids}}</td>
                  <td>{{item?.montant}}</td>
                  <td>

                    <a (click)="openTacheModal(item)" style="cursor: pointer;" class="me-3 text-primary"
                      v-b-tooltip.hover title="Tache">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>
                    <a (click)="EditModal(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover
                      title="Edit">
                      <i class="mdi mdi-pencil font-size-18"></i>
                    </a>
                    <a (click)="confirmDeletion(item)" href="javascript:void(0);" class="text-danger" v-b-tooltip.hover
                      title="Delete">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>&nbsp;
                    <!-- <a (click)="addProjetToActiviter(item)" href="javascript:void(0);" class="me-3 text-primary" v-b-tooltip.hover title="Ajouter une  activité">
                      <i class="mdi mdi-plus font-size-18"></i>
                    </a> -->
                  </td>
                </tr>

              </tbody>
            </table>


          </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isLoading === true">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Chargement en cours</h5>
                <div class="loader4"></div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="paginatedItems.length === 0 && isLoading === false" class="d-flex justify-content-center">
          <div class="container">
            <div class="row">
              <div class="text-center">
                <h5 id="graycolor">Aucune donnée trouvée</h5>
              </div>
            </div>
          </div>

        </div>
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
      </div>

    </div>
  </div>
</div>





<ng-template #tacheModal let-modal>

  <br>
  <div class="d-flex justify-content-between align-items-center">
    <h4>Tache ({{tacheItems.length}})</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Close click')"> </button>
  </div>
  <div class="table-responsive mt-3">
    <table class="table table-centered datatable dt-responsive nowrap"
      style="border-collapse: collapse; border-spacing: 0; width: 100%;">
      <thead class="thead-light  rwd-table">
        <tr>
          <th style="white-space: nowrap;">code</th>
          <th style="white-space: nowrap;">Libellé</th>
          <th style="white-space: nowrap;">Date début</th>
          <th style="white-space: nowrap;">Date fin</th>
          <th style="white-space: nowrap;"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginatedTacheItems; let index = index">
          <td>{{item?.code}}</td>
          <td>{{item?.libelle}}</td>
          <td>{{item?.date_debut | dateFormat}}</td>
          <td>{{item?.date_fin | dateFormat}}</td>
          <td>
            <a (click)="EditModalTache(item)" style="cursor: pointer;" class="me-3 text-primary" v-b-tooltip.hover
              title="Edit">
              <i class="mdi mdi-pencil font-size-18"></i>
            </a>
            <a (click)="confirmDeletionTache(item)" href="javascript:void(0);" class="text-danger" v-b-tooltip.hover
              title="Delete">
              <i class="mdi mdi-trash-can font-size-18"></i>
            </a>&nbsp;
            <!-- <a (click)="addProjetToActiviter(item)" href="javascript:void(0);" class="me-3 text-primary" v-b-tooltip.hover title="Ajouter une  activité">
                      <i class="mdi mdi-plus font-size-18"></i>
                    </a> -->
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #editTacheModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Modifier Tâche</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>

  <div class="modal-body">
    <div class="mb-3">
      <label>Libellé</label>
      <input type="text" class="form-control" [(ngModel)]="editItem.libelle">
    </div>

    <div class="mb-3">
      <label>Date début</label>
      <input type="date" class="form-control" [(ngModel)]="editItem.date_debut">
    </div>

    <div class="mb-3">
      <label>Date fin</label>
      <input type="date" class="form-control" [(ngModel)]="editItem.date_fin">
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Annuler</button>
    <button class="btn btn-primary" (click)="saveEdit()">Enregistrer</button>
  </div>
</ng-template>




<p-confirmDialog />
<p-toast />
